import { createFileRoute } from '@tanstack/react-router';
import { AdvisorDetailRoute } from '@/pages/advisors/detail-route';

/** Deep link al dettaglio: la lista sta già sotto, montata dal layout. */
export const Route = createFileRoute('/admin/_layout/advisors/_layout/$id')({
  component: AdvisorDetailRouteComponent,
});

function AdvisorDetailRouteComponent() {
  const { id } = Route.useParams();

  return <AdvisorDetailRoute id={id} />;
}
